import React from 'react';
import PropTypes from 'prop-types';

import Talk from './Talks/Talk';

const Talks = ({ data = [] }) => (
  <div className="talks">
    <div className="link-to" id="talks" />
    <div className="title">
      <h3>Selected Talks</h3>
      <p>A full list is available on request.</p>
    </div>
    {data.map((talk) => (
      <Talk
        data={talk}
        key={`${talk.event}-${talk.title || ''}`}
      />
    ))}
  </div>
);

Talks.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    event: PropTypes.string,
    link: PropTypes.string,
  })),
};

export default Talks;
